/**
 * AskUpsellDark — dark teal PRO upsell card for the Ask page (redesign 1i).
 * Price comes from the billing system (Stripe via /billing/config) — never
 * hardcoded. Renders nothing while billing is dark-deployed (kill switch).
 * Mobile (<sm): stacks — text above button.
 */
import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";
import { useBillingConfig } from "./ProUpsellCard";

export function formatPlanPrice(p) {
  if (!p || p.amount == null) return null;
  try {
    const nf = new Intl.NumberFormat("en", {
      style: "currency",
      currency: p.currency || "EUR",
      minimumFractionDigits: 0,
      maximumFractionDigits: p.amount % 1 ? 2 : 0,
    });
    return `${nf.format(p.amount)}/${p.interval === "year" ? "yr" : "mo"}`;
  } catch {
    return null;
  }
}

export default function AskUpsellDark({ proLimit = 100 }) {
  const cfg = useBillingConfig();
  const fired = useRef(false);

  useEffect(() => {
    if (!cfg?.enabled || fired.current) return;
    fired.current = true;
    try { window.posthog?.capture("paywall_viewed", { surface: "ask" }); } catch { /* best-effort */ }
  }, [cfg]);

  if (!cfg?.enabled) return null;
  const priceLabel = formatPlanPrice(cfg.prices?.monthly);

  return (
    <div data-testid="ask-upsell-dark"
      className="rounded-2xl p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center gap-4 sm:justify-between"
      style={{ background: "#0f2529", boxShadow: "0 8px 28px rgba(15,37,41,0.25)" }}>
      <div className="flex items-start gap-3 min-w-0">
        <Sparkles className="w-4 h-4 mt-0.5 shrink-0" style={{ color: "#8fd4dc" }} />
        <div>
          <p className="text-sm font-semibold text-white">TourismIntel PRO — {proLimit} Ask questions/month</p>
          <p className="text-xs mt-1 leading-relaxed" style={{ color: "#9db7bb" }}>
            Full 3-month archive · unlimited semantic search · themed digests &amp; story clusters
          </p>
        </div>
      </div>
      <Link to="/pro" data-testid="ask-upsell-dark-cta"
        onClick={() => { try { window.posthog?.capture("paywall_clicked", { surface: "ask", price: priceLabel || null }); } catch { /* best-effort */ } }}
        className="shrink-0 self-start sm:self-auto flex items-center gap-1.5 px-5 py-2.5 rounded-full text-sm font-semibold transition-opacity hover:opacity-90"
        style={{ background: "#8fd4dc", color: "#0f2529" }}>
        Upgrade{priceLabel ? ` · ${priceLabel}` : ""}<ArrowRight className="w-3.5 h-3.5" />
      </Link>
    </div>
  );
}
